import React from "react";
import { RCCGrid, RCCIcon, RCCPopover } from "react-common-components";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { IAnalysisTraceability } from "src/pages/Analysis/SWOT/interface";
import swotLabels from "src/pages/Analysis/SWOT/SwotLabels";
import { SpanStyled } from "../../styles";


export interface IComponentAnalysisTraceability{
    traceability: IAnalysisTraceability;
}

const AnalysisTraceability: React.FC<IComponentAnalysisTraceability> = ({
	traceability
}) => {
	const { translate } = useTranslation();	
	const {importance,intensity,tendencyAnalysis} = swotLabels(translate);

	return(
		<>
			<RCCGrid container item>
				<RCCGrid container>
					<Title color="purple" bold>{translate("Análise")}:</Title>
					<SpanStyled>{traceability.maa001Titulo}</SpanStyled>
					{
						traceability.maa001Descricao &&
							<RCCPopover
								position="bottom"
								header={{title:translate("Descrição")}}
								body={{text:`${traceability.maa001Descricao}`}}
							>
								<RCCIcon
									style={{marginLeft: 5}}
									name="infoCircle"
									color="grey"
								/>
							</RCCPopover>
					}
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{traceability.maa001Label1}:</Title>
					<SpanStyled>{traceability.maa002Descricao}</SpanStyled>
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{traceability.maa001Label2}:</Title>
					<SpanStyled>{traceability.maa003Descricao}</SpanStyled>
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{traceability.maa001Label3}:</Title>
					<SpanStyled>{traceability.maa004Descricao}</SpanStyled>
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{translate("Importância")}:</Title>
					<SpanStyled>{importance[traceability.maa004Importancia-1].label}</SpanStyled>
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{translate("Intensidade")}:
					</Title>
					<SpanStyled>{intensity[traceability.maa004Probabilidade-1].label}</SpanStyled>
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{translate("Tendência")}:</Title>
					<SpanStyled>{tendencyAnalysis[traceability.maa004Tendencia-1].label}</SpanStyled>
				</RCCGrid>
				<RCCGrid container>
					<Title color="purple" bold>{translate("Pontuação")}:</Title>
					<SpanStyled>{traceability.maa004Pontuacao}</SpanStyled>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default AnalysisTraceability;
